<template>
    <div class="c-product-variation-line">
        <div class="c-product-delete">
            <button title="Product verwijderen uit lijst."
                    @click="deleteProduct"
                    class="c-button c-button--neutral c-button--tiny c-button--icon" type="button">
                <svgicon name="close"></svgicon>
            </button>
        </div>
        <div class="c-product-clear__sizes">
            <span @click.prevent="clearAllSizes">{{$t('fast_order.remove_all_sizes')}}</span>
        </div>
        <div class="u-flex-set o-gutter-large">
            <div class="c-product-color u-flex--push-right">
                <img v-if="variationImage" :src="variationImage" alt="" class="c-product-variation-image">
                <div v-else class="c-product-color-element" :style="`background-color: ${product.HexCode}`"></div>
                <p class="c-product-color-info">
                    <span class="u-font-weight-medium">{{ product.Name }}</span>
                    <span v-if="product.Color">({{ $t('product.line.color') }}: {{ product.ColorId }} {{ product.Color }})</span> <br>
                </p>
            </div>
        </div>

        <div class="c-product-seperator"></div>

        <div class="c-product-variation-line-sizes u-flexed-item--auto u-margin-bottom-tiny">
            <template v-if="isSizePants">
                <v-product-pants-sizes :items="product.Variants" :waist-sizes="product.VariantsDim1" :length-sizes="product.VariantsDim2"></v-product-pants-sizes>
            </template>
            <template v-else>
                <v-product-size-input v-for="item in productSizes" :key="item.Id" :item.sync="item"></v-product-size-input>
            </template>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VLoading from '@/components/Loading'
    import VSelect from '@/components/form/Select'
    import VInput from '@/components/form/Input'
    import VProductSizeInput from '@/components/product/widgets/FastOrderProductSizeInput.vue'
    import VProductPantsSizes from '@/components/shop/ShopProductPantsSizes'

    export default {
        components: {
            VLoading,
            VSelect,
            VInput,
            VProductSizeInput,
            VProductPantsSizes
        },
        props: {
            product: Object
        },
        data () {
            return {
                productSizes: this.product.Variants[0],
                isSizePants: this.product.SizeChartId === 2
            }
        },
        computed: {
            variationImage () {
                let output = null;
                if (this.product.Images.length) {
                    output = this.product.Images[0].replace('[WIDTH]', 60).replace('[HEIGHT]', 60);
                }
                return output;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            },
            isCustomerHidden() {
                return this.$store.getters.isCustomerHidden;
            }
        },
        methods: {
            deleteProduct() {
                const confirm = window.confirm('Product verwijderen?')
                if (confirm) {
                    this.$store.dispatch('deleteFastOrderProduct', this.product);
                }
            },
            clearAllSizes() {
                const confirm = window.confirm('Weet u zeker dat u alle ingevoerde maten wilt verwijderen?')
                if (confirm) {
                    this.$store.dispatch('deleteFastOrderProductSizes', this.product);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .deadline-date {
        font-size: 14px;
        font-style: italic;
    }

    .c-product-variation-line-sizes {
        flex-wrap: wrap;
    }

    .c-product-delete {
        position: absolute;
        top: em($global-spacing-unit-small);
        right: em($global-spacing-unit-small);
    }

    .c-product-clear__sizes {
        position: absolute;
        top: em($global-spacing-unit-small);
        right: em($global-spacing-unit-large);
        span {
            font-size: $font-size-extra-small;
            color: $color-alpha;
            text-decoration: underline;
            cursor: pointer;
            &:hover {
                color: black;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/product/customer/ProductVariationLine.vue